import React, { useState } from "react";
import { apiUrl } from "../lib/api";

const AuthForm = ({ isLogin, setIsLogin, onLogin }) => {
  const [role, setRole] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    if (!email || !password) {
      setError("Email and password are required.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(apiUrl("/api/auth/login"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.role);
        localStorage.setItem("username", data.username);
        localStorage.setItem("employeeId", data.employeeId || "");
        localStorage.setItem("userId", data.userId);
        localStorage.setItem("email", data.email || email);
        localStorage.setItem("phone", data.phone || "");
        localStorage.setItem("address", data.address || "");
        onLogin(data.role);
      } else {
        setError(data.message || "Invalid credentials.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!fullName.trim()) {
      setError("Full name is required.");
      return;
    }

    if (!email.trim()) {
      setError("Email is required.");
      return;
    }

    if (!role) {
      setError("Please select a role.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    const userData = {
      email: email.trim(),
      password,
      username: fullName.trim(),
      role,
      employeeId,
    };

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(apiUrl("/api/auth/register"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "An error occurred. Please try again.");
      } else {
        alert(`Success: ${data.message}`);
        setFullName("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setRole("");
        setEmployeeId("");
        setIsLogin(true);
      }
    } catch (err) {
      console.error("Registration error:", err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="auth-card__form" onSubmit={isLogin ? handleLogin : handleSubmit}>
      {error && <div className="auth-card__error">{error}</div>}

      {!isLogin && (
        <>
          <input
            className="auth-card__input"
            type="text"
            placeholder="Full Name"
            value={fullName}
            onChange={(event) => setFullName(event.target.value)}
            required
          />
          <select className="auth-card__input" value={role} onChange={(event) => setRole(event.target.value)} required>
            <option value="">Select Role</option>
            <option value="shopper">Shopper</option>
            <option value="employee">Employee</option>
            <option value="manager">Manager</option>
          </select>
          {(role === "employee" || role === "manager") && (
            <input
              className="auth-card__input"
              type="text"
              placeholder="Enter Employee or Manager ID"
              value={employeeId}
              onChange={(event) => setEmployeeId(event.target.value)}
              required
            />
          )}
        </>
      )}

      <input
        className="auth-card__input"
        type="email"
        placeholder="Email"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        required
      />
      <input
        className="auth-card__input"
        type="password"
        placeholder="Password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        required
      />

      {!isLogin && (
        <input
          className="auth-card__input"
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          required
        />
      )}

      {!isLogin && (
        <label className="auth-card__terms">
          <input type="checkbox" required />
          <span className="auth-card__terms-text">
            I understand this demo account is for testing shopper, employee, and manager flows inside IntelliGrocer.
            {" "}
            <span
              className="auth-card__terms-link"
              onClick={() => alert("Use the seeded demo accounts if you want to explore each role quickly.")}
            >
              Demo note
            </span>
          </span>
        </label>
      )}

      <button className="auth-card__submit" type="submit" disabled={loading}>
        {loading ? "Submitting..." : isLogin ? "Login" : "Sign Up"}
      </button>
    </form>
  );
};

export default AuthForm;
